import { render, staticRenderFns } from "./JCategorySelectPrevent.vue?vue&type=template&id=80afb31c&"
import script from "./JCategorySelectPrevent.vue?vue&type=script&lang=js&"
export * from "./JCategorySelectPrevent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80afb31c')) {
      api.createRecord('80afb31c', component.options)
    } else {
      api.reload('80afb31c', component.options)
    }
    module.hot.accept("./JCategorySelectPrevent.vue?vue&type=template&id=80afb31c&", function () {
      api.rerender('80afb31c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/JCategorySelectPrevent.vue"
export default component.exports